import { useEffect } from 'react';

import styled from 'styled-components';

import S from '../variables';
import { measureScrollRails } from '../../../Utils/helpers';

export const StyledModalWrapper = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding: 80px 20px;
  z-index: 102;
  background: ${S.overlay};
`;

export const Modal = ({ open, closeFn, children }) => {
  useEffect(() => {
    const paddingRight = document.body.style.paddingRight;
    document.body.style.paddingRight = measureScrollRails(document.body) + `px`;
    document.body.style.height = open ? 'calc(100vh + 1px)' : 'unset';
    document.body.style.overflow = open ? 'hidden' : 'visible';
    return () => {
      document.body.style.paddingRight = paddingRight;
      document.body.style.height = '';
      document.body.style.overflow = '';
    };
  }, [open]);
  return open ? (
    <StyledModalWrapper
      onClick={closeFn}
      className={open ? 'entered' : 'exited'}
    >
      {children}
    </StyledModalWrapper>
  ) : null;
};
